module.exports = __webpack_public_path__ + "img/TA-2021-BOP-Silver-RGB-400.35182f5e.png";